import React from 'react';
import TestimonialCard from '../../common/TestimonialCard/TestimonialCard';
import styles from './Testimonials.module.scss';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Akshay Khanna, ',
      role: 'Service Consultant',
      feedback:
        'Since using EMIfy, our payment collections have improved by 90% with zero manual intervention.',
    },
    {
      name: 'Ravi Sharma, ',
      role: 'Business Owner',
      feedback:
        'EMIfy made managing payments seamless and increased our efficiency by automating repetitive tasks.',
    },
    {
      name: 'Priya Menon, ',
      role: 'Finance Manager',
      feedback:
        'The automated reconciliation features of EMIfy saved countless hours for our finance team.',
    },
  ];

  return (
    <section className={styles.testimonials}>
      <h2>
        What Our <span>Customers</span> Say
      </h2>
      <div className={styles.carousel}>
        <div className={styles.cards}>
          {[...testimonials, ...testimonials, ...testimonials].map(
            (testimonial, idx) => (
              <TestimonialCard
                key={idx}
                name={testimonial.name}
                role={testimonial.role}
                feedback={testimonial.feedback}
              />
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
